import type { IconData } from '@stacksjs/iconify-core'

export const contentFolder: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M.16.65h4.9L8 3.59h7.84v11.76H.16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentFolder
